import { EMAIL, FOOTER, OFFICE, PHONE, SOCIALS } from "../content/site";
import { langFromPath, localePath } from "../i18n/lang";

export function Footer() {
  const { lang } = langFromPath(window.location.pathname);
  const socials = [
    ["Facebook", SOCIALS.facebookUrl],
    ["X", SOCIALS.twitterUrl],
    ["Instagram", SOCIALS.instagramUrl],
    ["YouTube", SOCIALS.youtubeUrl],
  ].filter((s): s is [string, string] => typeof s[1] === "string");
  return (
    <footer className="bg-sage text-ivory">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 md:grid-cols-[1.4fr_1.2fr_0.9fr] md:px-10 md:py-20">
        <div>
          <h2 className="font-display text-2xl leading-snug">{FOOTER.title}</h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-ivory/80">
            {FOOTER.body}
          </p>
          <a
            href={localePath(FOOTER.link.href, lang)}
            className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-sun underline-offset-4 hover:underline"
          >
            {FOOTER.link.label}
            <span aria-hidden="true">→</span>
          </a>
        </div>
        <div>
          <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-ivory/60">
            Quick Links
          </h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 text-sm">
            {FOOTER.quickLinks.map((l) => (
              <li key={l.label}>
                <a
                  href={
                    l.href.startsWith("/") ? localePath(l.href, lang) : l.href
                  }
                  className="flex min-h-11 items-center text-ivory/90 transition-colors hover:text-sun"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-ivory/60">
            Contact Us
          </h2>
          <a
            href={`mailto:${EMAIL}`}
            className="mt-4 block text-sm text-ivory/90 underline underline-offset-4 transition-colors hover:text-sun"
          >
            {EMAIL}
          </a>
          <a
            href={PHONE.tel}
            className="mt-2 block text-sm text-ivory/90 underline underline-offset-4 transition-colors hover:text-sun"
          >
            {PHONE.display}
          </a>
          <ul className="mt-4 flex flex-wrap gap-2.5 text-sm">
            {socials.map(([label, href]) => (
              <li key={label}>
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex min-h-11 items-center rounded-full border border-ivory/40 px-4 transition-colors hover:border-ivory hover:bg-ivory hover:text-sage"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-sm leading-relaxed text-ivory/80">
            Registered Office:
            <br />
            {OFFICE}
          </p>
        </div>
      </div>
      <div className="border-t border-ivory/10 bg-sage-deep px-5 py-4 text-center text-xs text-ivory/70">
        {FOOTER.copyright}
      </div>
    </footer>
  );
}
